/*
 * src/components/TransferSuccess/TransferSuccess.jsx
 * Description: Transfer success page
 * Copyright (c) 2021 PredictiveUX
 */
import React, { useEffect } from 'react';
import BoxContainer from '../BoxContainer/BoxContainer';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useStateMachine } from 'little-state-machine';
import get from 'lodash/get';
import split from 'lodash/split';
import {
  PaymintsButton,
  BUTTON_TYPE,
} from 'paymints-address-autocomplete-field';
import updateAction from '../CreateAccountWizard/updateAction';
import { useBankAccount } from '../../utils/service/service_bank_api';
import { useInstitutionLogo } from '../../utils/service/service_institution_logo';
import { sendEmailReceipt } from '../../reducers/transfer/TransferActions';
import useEscrowAccountFromTenant from '../../utils/service/service_tenant_api';
import { getQueryVariable } from '../../utils/util';
// import { InsuranceBannerAd } from "../BannerAds/";

// local imports
import InfoDisbursement from './InfoDisbursement';
import InfoTransfer from './InfoTransfer';
import SuccessTitle from './SuccessTitle';
import SummaryTransfer from './SummaryTransfer';
import css from '../../styles/modules/TransferDetails/transfersuccess.module.css';
import '../CreateAccountWizard/createAccount.css';

/**
 *
 * @param {*} props
 * @returns
 */
const TransferSuccess = (props) => {
  const { state } = useStateMachine(updateAction);
  const tenant = get(props, 'tenant');
  const { bankAccount } = useBankAccount(get(state, 'data.bankAccount.id', ''));
  const { destAccount } = useEscrowAccountFromTenant(
    get(props, 'tenant._id', ''),
  );
  const { institutionLogo: bankAccountLogo } = useInstitutionLogo(
    get(bankAccount, 'institutionCode', ''),
  );
  const { institutionLogo: escrowAccountLogo } = useInstitutionLogo(
    get(destAccount, 'institutionCode', ''),
  );
  const pathUrl = get(split(props.location.search, '?'), 2);
  const disbursement = getQueryVariable(pathUrl, 'disbursement');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={css.wrapper}>
      <BoxContainer withDoubleBorder withTopLogo widest>
        <SuccessTitle />

        {/* disbursement or non-disbursement */}
        {!disbursement ? <InfoTransfer /> : <InfoDisbursement />}

        {/* this is the from -> to arrow component */}
        <SummaryTransfer
          transfer={get(state, 'data.transfer')}
          tenant={tenant}
          bankAccount={bankAccount}
          destAccount={destAccount}
          bankAccountLogo={get(bankAccountLogo, 'logoURL')}
          escrowAccountLogo={get(escrowAccountLogo, 'logoURL')}
          disbursement={disbursement}
        />

        <div className="create-account__footer-buttons">
          <PaymintsButton
            className="create-account__button"
            noShadow
            type={BUTTON_TYPE.INVERSE_BLUE}
            onClick={() => {
              props.history.push('/transfer-history');
              window.location.reload();
            }}
          >
            {'Transfer history'}
          </PaymintsButton>
        </div>
      </BoxContainer>
    </div>
  );
};

export default withRouter(
  connect(
    (state) => ({
      transferService: state.transfer,
    }),
    {
      onSendEmailReceipt: sendEmailReceipt,
    },
  )(TransferSuccess),
);
